import React from 'react';

export function IntegrationsHeader() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginBottom: '24px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1 style={{ 
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'var(--admin-card-text)', 
          fontSize: '37.9px', 
          fontWeight: 700, 
          margin: '0 0 6px', 
          letterSpacing: '-0.76px',
          lineHeight: '38px'
        }}>
          Integrations
        </h1>
        <p style={{ 
          fontFamily: "'Inter', sans-serif",
          color: '#7C8891', 
          fontSize: '14px', 
          margin: 0, 
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: '0'
        }}>
          Connect your essential communication and CRM tools to power up your pre-call intelligence.
        </p>
      </div>
    </div>
  );
}
